import React from 'react';
import { Tabs, Tab } from 'react-bootstrap-tabs';
import '../../styles/yourOrders.css';
import Button from 'react-bulma-components/lib/components/button';
import { Redirect } from 'react-router-dom'
const someDummyData = [
    {
        orderId: 123,
        userId: 123,
        // Dimension: "10x10",
        technique: "Watercolor on canvas",
        imgUrl: [{ url1: require('../../assets/painting1.png') },
        { url: require('../../assets/painting2.png') },
        { url: require('../../assets/painting3.png') }],
        imgName: "The electric pikachu",
        cost: "500",
        status: "APPROVED",
        timeOfOrder: "19 October 2018",
        requestBy: "namrata"

    },
    {
        orderId: 123,
        userId: 123,
        // Dimension: "10x10",
        technique: "Watercolor on canvas",
        imgUrl: [{ url1: require('../../assets/painting1.png') },
        { url: require('../../assets/painting2.png') },
        { url: require('../../assets/painting3.png') }],
        imgName: "The electric pikachu",
        cost: "500",
        status: "PENDING",
        timeOfOrder: "19 October 2018",
        requestBy: "namrata"
    },
    {
        orderId: 123,
        userId: 123,
        // Dimension: "10x10",
        technique: "Watercolor on canvas",
        imgUrl: [{ url1: require('../../assets/painting1.png') },
        { url: require('../../assets/painting2.png') },
        { url: require('../../assets/painting3.png') }],
        imgName: "The electric pikachu",
        cost: "500",
        status: "DECLINED",
        timeOfOrder: "19 October 2018",
        requestBy: "namrata"
    },
]

export default class myRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buyingTab: "visible",
            sellingTab: "hidden",
            viewArtwork: false,
            clearRequest: false,
            declineRequest: false,
            acceptRequest: false
        }
    }
    toggleBuyingTab() {
        this.setState({
            buyingTab: "visible",
            sellingTab: "hidden"

        })
        // console.log("buying", this.state.buyingTab)
        // console.log("selling", this.state.sellingTab)
    }
    toggleSellingTab() {
        this.setState({
            buyingTab: "hidden",
            sellingTab: "visible"

        })
        // console.log("buying", this.state.buyingTab)
        // console.log("selling", this.state.sellingTab)
    }

    handleBtnClicks(item) {
        switch (item) {
            case ("viewArtwork"): {
                this.setState({
                    viewArtwork: true
                })
                break;
            }
            case ("declineRequest"): {
                this.setState({
                    declineRequest: true
                })
                break;
            }
            case ("acceptRequest"): {
                this.setState({
                    acceptRequest: true
                })
                break;
            }
        }
    }
   
    render() {
        if (this.state.viewArtwork) {
            return (
                <Redirect push to="/product/details" />
            )
        }
        if (this.state.acceptRequest) {
            return (
                <Redirect push to="/accept-buy-request" />
            )
        }
        if (this.state.declineRequest) {
            return (
                <Redirect push to="/decline-buy-request" />
            )
        }

        return (
            <div className="back">
                <div className="heading-welcome">
                    VIEW REQUESTS
                    <hr className="line-category-name margin-auto"></hr>
                </div>
                <div className="container yourOrders" id="container-order-details">
                    <div className="content" style={{ backgroundColor: "#F6F6F6", display: "flex", flexDirection: "column" }}>
                        <Tabs className="tabs pb-25" style={{ backgroundColor: "#FFFF", marginLeft: "30%", margin: "0px auto", minWidth: "100%", justifyContent: "center", flex: 1 }}>
                            <Tab label=" Sent" className="tab-button-buying" onClick={this.toggleBuyingTab.bind(this)}  >
                                <div className="tabs-container">
                                    <Sent someDummyData={someDummyData} handleBtnClicks = {this.handleBtnClicks.bind(this)}/>
                                </div>
                            </Tab>
                            <Tab label="Received" className="tab-button-buying" onClick={this.toggleSellingTab.bind(this)} >
                                <div className="tabs-container">
                                    <Received someDummyData={someDummyData} handleBtnClicks = {this.handleBtnClicks.bind(this)} />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }

}

const Sent = (props) => {
    let { someDummyData ,handleBtnClicks} = props;

    return (
        someDummyData.map((el, elIndex) =>
            <div key={elIndex} className="small-content-box" style={{ paddingLeft: "0%", display: (el.status == "PENDING") ? "none" : "" }}>
                <div className="order-details-section">
                    <div className="order-display-picture-thumbnail">
                        <img style={{ height: "100%", width: "100%" }} src={require('../../assets/painting2.png')}></img>
                    </div>
                    <div className="order-name-technique-status">
                        <div className="order-name">
                            {el.imgName}
                        </div>
                        <div className="order-technique">
                            {el.technique}@{el.cost}
                        </div>
                        <div className="order-status">

                            <StatusBar someDummyData={el} />
                            {/* <ApprovedStatusBar someDummyData={el} /> */}
                        </div>
                    </div>
                    <div className="order-detail-btn-selling">

                        <SentReqTabBTN status={el.status} handleBtnClicks = {handleBtnClicks}/>
                        <div className="time-of-order sell-time" id="time-of-order-details" >
                            {el.timeOfOrder}
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}
const Received = (props) => {

    let { someDummyData,handleBtnClicks } = props;
    return (
        someDummyData.map((el, elIndex) =>
            <div key={elIndex} className="small-content-box" style={{ paddingLeft: "0%" }}>
                <div className="order-details-section">
                    <div className="order-display-picture-thumbnail">
                        <img style={{ height: "100%", width: "100%" }} src={require('../../assets/painting2.png')}></img>
                    </div>
                    <div className="order-name-technique-status">
                        <div className="order-name">
                            {el.imgName}
                        </div>
                        <div className="order-technique" style={{ display: "flex" }}>
                            <div style={{ flex: 1 }}>Requested by @ </div><div className="request-username" style={{ margin: "unset", padding: "unset" }}>{el.requestBy}</div>
                        </div>
                        <div className="order-status">
                            {/* <InProgressStatusBar someDummyData={el} /> */}
                            <StatusBar someDummyData={el} />
                        </div>
                    </div>
                    <div className="order-details-btn" style={{ display: "flex", flexDirection: "column" }}>
                        <div className="rightelem">
                            <Button onClick={() =>handleBtnClicks("declineRequest")} id="order-details-button" style={{ display: (el.status == "PENDING") ? "" : "none", float: "right" }} className="masterpieces-tertiary-black-button ml-15 btn-pt8-pr-25" >DECLINE</Button>
                            <ReceivedReqTabBTN handleBtnClicks= {handleBtnClicks} status={el.status} />
                        </div>
                        <div className="time-of-order" >
                            {el.timeOfOrder}
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}

const SentReqTabBTN = (props) => {
    let { status,handleBtnClicks } = props;
    if (status == "APPROVED")
        return (
            <Button onClick={() => handleBtnClicks("viewArtwork")} style={{float: "right"}} id="order-details-button"
                    className={"masterpieces-primary-buttons btn-pt8-pr-25"}>VIEW ARTWORK</Button>

        )
    if (status == "DECLINED")
        return (

            <Button onClick={() => handleBtnClicks("clearRequest")} style={{float: "right"}} id="order-details-button"
                    className={"masterpieces-secondary-buttons btn-pt8-pr-25"}>CLEAR REQUEST</Button>
        )
    else return <div></div>
}


const ReceivedReqTabBTN = (props) => {
    let { status,handleBtnClicks } = props;
    if (status == "PENDING")
        return (
            <Button onClick={() =>handleBtnClicks("acceptRequest")} style={{ float: "right" }} id="order-details-button" className={"masterpieces-primary-buttons btn-pt8-pr-25"} >APPROVE</Button>

        )
    if (status == "DECLINED")
        return (

            <Button onClick={() =>handleBtnClicks("clearRequest")} style={{ float: "right" }} id="order-details-button" className={"masterpieces-secondary-buttons btn-pt8-pr-25"} >CLEAR REQUEST</Button>
        )
    if (status == "APPROVED")
        return (
            <Button onClick={() =>handleBtnClicks("declineRequest")} style={{ float: "right" }} id="order-details-button" className={"masterpieces-primary-buttons btn-pt8-pr-25"} >DECLINE</Button>

        )
    else return <div></div>
}




const StatusBar = (props) => {
    let { someDummyData } = props;
    if (someDummyData.status == "DECLINED")
        return (
            <div className="declined-Status-Bar" style={{ display: (someDummyData.status == "DECLINED") ? "" : "none" }}>
                <div className="status-name">DECLINED</div>
            </div>
        )

    if (someDummyData.status == "APPROVED")
        return (
            <div className="delivered-Status-Bar" style={{ display: (someDummyData.status == "APPROVED") ? "" : "none" }}>
                <div className="status-name">APPROVED</div>
            </div>
        )
    else return <div></div>
}



// WEBPACK FOOTER //
// ./src/components/requests/myRequests.js